import React, { useLayoutEffect } from 'react';
import { Navigate } from 'react-router';
import EnsureUser from './EnsureUser';
import { UIActions } from '../../ui/uiSlice';
import useAppSelector, { useAppDispatch } from '../redux/useAppSelector';

interface EnsureAdminProps {
  children: JSX.Element;
}

const EnsureAdmin = ({ children }: EnsureAdminProps) => {
  const { id, type } = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    if (id && type !== 'ADMIN') {
      dispatch(
        UIActions.pushToast({
          level: 'warning',
          message: 'Must be an admin to do that.',
        }),
      );
    }
  }, [dispatch, id, type]);

  if (!id) return <EnsureUser />;

  if (type !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default EnsureAdmin;
